
// @ts-ignore
import {throttle} from "throttle-debounce";

function setupSeeMoreEvents() {
	let $seeMore = $('.js-see-more');

	$seeMore.each(function(){
		let $this = $(this);
		let $seeMoreLink = $this.find('.see-more-expander__link');
		let $seeMoreInnerContent = $(this).find('.js-see-more-inner');
		let $seeMoreContent = $this.find('.see-more-expander__content');
		let $maxHeight = $this.data('max-height');

		$seeMoreContent.css("max-height", $maxHeight);

		//($seeMoreInnerContent.height());
		//console.log($maxHeight);

		function checkHeight() {
			if($seeMoreInnerContent.height() >= $maxHeight) {
				$seeMoreContent.addClass('state-overflowing');
				$seeMoreLink.addClass('state-visible');
			} else {
				$seeMoreLink.removeClass('state-visible');
				$seeMoreContent.removeClass('state-overflowing');
			}
		}

		checkHeight();

		$(window).on('resize', (throttle as any)(40, false, (event) => {
			checkHeight();
		}));

		$seeMoreLink.on('click', function(e){
			e.preventDefault();
			if($this.hasClass('state-expanded')) {
				$this.removeClass('state-expanded');
				$seeMoreContent.css("max-height", $maxHeight);
			} else {
				$this.addClass('state-expanded');
				$seeMoreContent.css("max-height", '10000px');
			}

		});
	});
}

export function init() {
	setupSeeMoreEvents();
}
